import React from 'react';
import { Activity, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import type { UserActivity } from '../../types/user';

interface ActivityLogProps {
  activities: UserActivity[];
}

const ActivityLog: React.FC<ActivityLogProps> = ({ activities }) => {
  const getIcon = (action: string) => {
    switch (action) {
      case 'login':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case 'failed_login':
        return <XCircle className="h-5 w-5 text-red-500" />;
      case 'password_change':
        return <Activity className="h-5 w-5 text-blue-500" />;
      case 'permission_change':
        return <AlertTriangle className="h-5 w-5 text-yellow-500" />;
      default:
        return <Activity className="h-5 w-5 text-gray-500" />;
    }
  };

  const getActionText = (action: string) => {
    switch (action) {
      case 'login':
        return 'Realizou login';
      case 'failed_login':
        return 'Tentativa de login falhou';
      case 'password_change':
        return 'Alterou a senha';
      case 'permission_change':
        return 'Permissões alteradas';
      default:
        return action;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-lg font-medium text-gray-900">
          Log de Atividades
        </h2>
      </div>

      <div className="p-6">
        <div className="flow-root">
          <ul className="-mb-8">
            {activities.map((activity, index) => (
              <li key={activity.id}>
                <div className="relative pb-8">
                  {index !== activities.length - 1 ? (
                    <span
                      className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200"
                      aria-hidden="true"
                    />
                  ) : null}
                  <div className="relative flex items-start space-x-3">
                    <div className="relative">
                      {getIcon(activity.action)}
                    </div>
                    <div className="min-w-0 flex-1">
                      <div>
                        <div className="text-sm text-gray-500">
                          {getActionText(activity.action)}
                        </div>
                        <p className="mt-0.5 text-sm text-gray-500">
                          {new Date(activity.timestamp).toLocaleString()}
                        </p>
                      </div>
                      {activity.details && (
                        <div className="mt-2 text-sm text-gray-700">
                          <p>
                            {activity.ip && (
                              <span className="text-gray-500">
                                IP: {activity.ip}
                              </span>
                            )}
                            {activity.userAgent && (
                              <span className="text-gray-500 ml-2">
                                • {activity.userAgent}
                              </span>
                            )}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ActivityLog